// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__3tvV3","light":"CloseButton_light__2iS1-"};